export type VolumePage = {
  src: string
  /** Shown under the page and used as its alt text. */
  caption: string
}

/** Volume 4 — Owning the Room. Pages are shown exactly as exported, in this order. */
export const volumePages: VolumePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/1WBVt1kKHTttAQEhiGmHCc/01-cover_1.png',
    caption: 'Your new go-to volume on delivery: voice, body and eyes.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/b7oeETwYQrnQEMTfkqHztA/02-presence-triangle.png',
    caption: 'One simple model: voice, body and eyes, three sides that hold the room.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ke9FNRba3GzWsb4tVEkdki/03-fidget-vs-frame.png',
    caption: 'Before/after pages your group gets at a glance.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/fUjJVq7uPB5JDaNBfvUh1t/04-nerve-to-energy_1.png',
    caption: 'Turn stage fright into energy, with a 3-step switch.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kZouEH47Bk6872KZsjwvRE/05-field-card_1.png',
    caption: 'The whole volume on one printable field card.',
  },
]
